<template>
    <div>
      <div class="card mb-3">
          <div class="row no-gutters" style="min-height: 56vh; overflow: auto;">
            <div class="col-md-3" style="border-right: 1px solid #e0e0e0">
              <div class="card-body">
                  <div class="filter-bar ui basic segment grid">
                    <div class="ui form">
                      <div class="inline field">
                          <h6 class="heading-small text-muted mb-4">Search</h6>
                          <div class="input-group mb-3">
                              <input type="text" class="form-control" :placeholder="placeholder" @keyup.enter="doFilter" v-model="filterText">
                              <div class="input-group-append">
                                <base-dropdown v-model="searchFilter">
                                    <base-button slot="title" type="secondary" class="btn-outline-primary dropdown-toggle dropdown-toggle-split" style="border-top-left-radius: 0px;border-bottom-left-radius: 0px;"/>
                                    <a class="dropdown-item" @click.prevent="changeSearchFilter('name')">Name</a>
                                </base-dropdown>
                              </div>
                          </div>
                          <hr class="my-4" />
                          <h6 class="heading-small text-muted mb-4">Filter by status</h6>
                          <div>
                              <base-radio name="0" class="mb-3" v-model="filterStatus" value="O">
                                  All
                              </base-radio>
                              <base-radio name="A" class="mb-3" v-model="filterStatus" value="A">
                                  Activated
                              </base-radio>
                              <base-radio name="D" class="mb-3" v-model="filterStatus" value="D">
                                  Deactivated
                              </base-radio>
                              <base-radio name="P" class="mb-3" v-model="filterStatus" value="P">
                                  For Approval
                              </base-radio>
                          </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
            <div class="col-md-9" >
              <div class="card-body">
                  <div class="ml-2"><h2 class="card-title">Developer Accounts</h2></div>
                  <a-table :scroll="{ x: 1000 }" size="small" rowKey="id" :columns="columns" :data-source="data" style="min-height: 50vh; overflow: auto;">
                      <span slot="status" slot-scope="text, record">
                          <a-tag v-if="record.status == 'A'" color="green">Activated</a-tag>
                          <a-tag v-if="record.status == 'P'" color="red">Pending</a-tag>
                          <a-tag v-if="record.status == 'D'">Deactived</a-tag>
                      </span>
                      <span slot="action" slot-scope="text, record">
                          <button v-if="record.status == 'P'" class="btn btn-success btn-sm" @click.prevent="approve(record)">Approve</button>
                          <button v-if="record.status == 'D'" class="btn btn-info btn-sm" @click.prevent="activate(record)">Activate</button>
                          <button v-if="record.status == 'A'" class="btn btn-danger btn-sm" @click.prevent="deactivate(record)">Deactivate</button>
                      </span>
                  </a-table>
              </div>
            </div>
          </div>
      </div>
    </div>

</template>

<script>
import HTTPRequest from '../../controllers/httpRequest.js'
import secureStorage from '../../controllers/secureStorage.js'
import { mapState, mapActions } from 'vuex'

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    fixed: 'left',
  },
  {
    title: 'Email',
    dataIndex: 'email',
  },
  {
    title: 'Status',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: 'Approved By',
    dataIndex: 'approved_by',
    ellipsis: true,
  },
  {
    title: 'Approved At',
    dataIndex: 'approved_at',
    ellipsis: true,
  },
  {
    title: 'Action',
    scopedSlots: { customRender: 'action' },
    fixed: 'right'
  },
];

export default {
  mounted: async function(){  
    
  },
  computed: {
       ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
  },
  watch: {
    filterStatus: function() {
      this.retrieveDeveloperAccounts(null, this.filterStatus)
      this.filterText = ''
    }
  },
  data () {
    return {
        selectedProfile: "developer_accounts",
        columns,
        data: [],
        userCode: secureStorage.getItem("userCode"),
        filterStatus: '0',
        searchFilter: "name",
        placeholder: "Search by name",
        filterText: '',
    }
  },
  mounted: async function(){
    this.retrieveDeveloperAccounts()
  },
  methods: {
    async retrieveDeveloperAccounts(search, status){
      if (search == null && (status == null || status == '0')) {
        var developer_accounts = await HTTPRequest.getRequest(this.endPoint + 'developer_accounts', null)
        if (developer_accounts) this.data = developer_accounts['data']
      } else if (status != null)  {
       
        var developer_accounts = await HTTPRequest.getRequest(this.endPoint + 'developer_accounts?status='+status, null)
        if (developer_accounts) this.data = developer_accounts['data']
      } else if (search != null) {
    
        var developer_accounts = await HTTPRequest.getRequest(this.endPoint + 'developer_accounts?name='+search, null)
        if (developer_accounts) this.data = developer_accounts['data']
      } else if (status != null && search != null){
        
        var developer_accounts = await HTTPRequest.getRequest(this.endPoint + 'developer_accounts?name='+search+'&status='+status, null)
        if (developer_accounts) this.data = developer_accounts['data']
      }
    },
    notify(action){
      this.$notification['success']({
          message: 'Developer Account',
          description: "Success " + action + " account"
      });
    },
    async approve(record) {
      var developer_account_payload = {"status": "A", "approved_by": this.userCode, "updated_by": this.userCode}
      var developer_account = await HTTPRequest.putRequest(this.endPoint + 'developer_accounts/'+record.id, null, developer_account_payload)
      if (developer_account.status == 'A') {
        this.notify('approving');
      }
      this.retrieveDeveloperAccounts();
      this.$parent.retrieveStatistics();
    },
    async activate(record) {
      var developer_account_payload = {"status": "A", "updated_by": this.userCode}
      var developer_account = await HTTPRequest.putRequest(this.endPoint + 'developer_accounts/'+record.id, null, developer_account_payload)
      if (developer_account.status == 'A') {
        this.notify('activating');
      }
      this.retrieveDeveloperAccounts();
      this.$parent.retrieveStatistics();
    },
    async deactivate(record) {
      var developer_account_payload = {"status": "D", "updated_by": this.userCode}
      var developer_account = await HTTPRequest.putRequest(this.endPoint + 'developer_accounts/'+record.id, null, developer_account_payload)
      if (developer_account.status == 'D') {
        this.notify('deactivating');
      }
      this.retrieveDeveloperAccounts();
      this.$parent.retrieveStatistics();
    },
    setCurrentProfile(profile){
      this.selectedProfile = profile
    },
    changeSearchFilter(searchFilter){
      this.searchFilter = searchFilter
      this.placeholder = "Search by " + searchFilter
    },
    doFilter(){
      this.retrieveDeveloperAccounts(this.filterText, null)
    },
  },
}
</script>

<style>
</style>


